
import HeadBar from '../HeadBar/HeadBar';
import Popup from 'vux/src/components/popup/index.vue'

import CellRow from '../Cell/CellRow';
import {OrderProxy} from '@/http/RequestProxy.class';

export default {
name: 'area-code-selector',
components: {
CellRow,
HeadBar,
Popup,
},
props: {
value: Boolean,
},
data(){
return {
isShowDefaultArea: true,   // 显示默认的地区列表
keyword: '',
isFocus: false,     // 是否获得焦点
defaultCodeList: [],  // 未做处理的地区数据
areaCodeList: [],   // 默认地区列表数据
hotAreaCodes: [],   // 热门地区列表
searchCodeList: [],     // 搜索匹配列表
};
},
computed: {

isShowSelector: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
},
}
},
mounted(){
this.getAreaCodeData();
},
methods: {
/** 获取国家地区号数据 */
getAreaCodeData(){
new OrderProxy().getCountryPhoneCode()
.then(resp => {
if(resp){
this.defaultCodeList = resp.data.phone_code_list;
this.hotAreaCodes = resp.data.hot_country_list;
this.sortPhoneCodeList(resp.data.phone_code_list);
}
});
},

/** 对国家地区号进行排序 */
sortPhoneCodeList(areaCodeList){

for(let i = 0; i < areaCodeList.length - 1; i++){
let isSorted = true;    

for(let j = 0; j < areaCodeList.length - 1 - i; j++){
if(areaCodeList[j].first_word > areaCodeList[j + 1].first_word){
let temp = areaCodeList[j + 1];

areaCodeList[j + 1] = areaCodeList[j];
areaCodeList[j] = temp;
isSorted = false;   
}
}

if(isSorted) break;
}

let targetArr = [];   
let currentIdx = 0;   


areaCodeList.forEach(function (item, idx, arr) {
if(idx > 0){
if(arr[idx - 1]['first_word'] !== item['first_word']){
targetArr.push(arr.slice(currentIdx, idx));
currentIdx = idx;
}
}

if(idx === arr.length - 1){
targetArr.push(arr.slice(currentIdx, idx));
}
});

this.areaCodeList = targetArr;
},

/** 获得焦点 */
onFocus(){
this.isFocus = true;
},

/** 失去焦点 */
hideSelector(){
this.keyword = '';
this.searchCodeList = [];
this.isFocus = false;
this.isShowSelector = false;
},

/** 根据关键字匹配国家 */
searchAreaWithKeyword(){
const result = [];

this.defaultCodeList.forEach((item, idx) => {
if(this.keyword && item.country_name.indexOf(this.keyword) > -1){
result.push(item);
}
});

this.searchCodeList = result;
},

/** 选择地区号 */
onSelectCode(areaCode){
this.hideSelector();
this.$emit('get-phone-code', areaCode);
},
},
}



// WEBPACK FOOTER //
// ./src/components/AreaCodeSelector/AreaCodeSelector.vue